  <div class="facial-biometric-container text-center mt-2 p-4 border-1">
    <!-- Step 1: Instructions -->
    <div v-if="step === 'instructions'">
      <p class="text-danger fw-bold text-xs">
        Ensure your camera is enabled and working.
      </p>
      <ul class="list-unstyled text-start mt-3 p-1">
        <li><i class="bi bi-camera me-2 text-x fw-bold "></i> Look directly into the camera</li>
        <li><i class="bi bi-sun me-2 text-x fw-bold"></i> Ensure good lighting</li>
        <li><i class="bi bi-person-bounding-box me-2 text-x fw-bold"></i> Center your face in the frame</li>
        <li><i class="bi bi-emoji-neutral me-2 text-x fw-bold"></i> Keep a neutral expression</li>
      </ul>
      <div class="mt-4">
        <button class="btn btn-sm btn-primary-dark text-xxs fw-bold" @click="go_to_camera">
          Take Photo
        </button>
      </div>
    </div>

    <!-- Step 2: Camera / Selfie -->
    <div v-else-if="step === 'camera'">
      <p class="text-dark text-xxs">
        It's Selfie Time!<br>
        <span class="fw-bold text-danger text-xxs">Please make sure you have your camera enabled!</span>
        <br>This will assist us to source the basic personal details we need to process your application.
      </p>

      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <!-- Display User ID -->
            <input
              type="text"
              class="form-control form-control-sm border-1 py-1 rounded-lg mb-3 text-xxs"
              :value="user_profile_data.id_number"
              readonly
            />
          </div>

          <div class="col-12 text-center">
            <figure
              class="position-relative d-flex justify-content-center align-items-center custom-height mb-3 border table-border-color rounded-lg"
            >
              <!-- Loading state -->
              <div
                v-if="camera_loading"
                class="position-absolute d-flex justify-content-center align-items-center w-100 h-100 bg-light"
              >
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Loading camera...</span>
                </div>
              </div>

              <!-- Error state -->
              <div
                v-else-if="camera_error"
                class="position-absolute d-flex flex-column justify-content-center align-items-center w-100 h-100 bg-light"
              >
                <i class="bi bi-camera-video-off fs-1 text-danger mb-2"></i>
                <p class="text-danger mb-3">Camera unavailable</p>
                <button @click="init_camera" class="btn btn-sm btn-primary-dark text-xxs fw-bold">
                  Retry Camera
                </button>
              </div>

              <!-- Video feed -->
              <video
                ref="video"
                autoplay
                loop
                muted
                playsinline
                class="position-absolute w-100 h-100 rounded-lg"
                :class="{ 'd-none': photo_taken || camera_loading || camera_error }"
              ></video>

              <!-- Canvas overlay -->
              <canvas
                ref="canvas"
                class="position-absolute w-100 h-100"
                :class="{ 'd-none': !photo_taken || camera_loading || camera_error }"
              ></canvas>

              <!-- Circle overlay -->
              <div class="circle-overlay position-absolute"></div>
            </figure>

            <!-- Buttons -->
            <div
              class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-2"
            >
              <button
                v-if="!photo_taken && !camera_loading && !camera_error"
                @click="take_photo"
                class="btn btn-sm btn-primary-dark text-xxs fw-bold"
              >
                Take Photo
              </button>

              <button
                v-else-if="photo_taken && !camera_loading && !camera_error"
                @click="retake_photo"
                class="btn btn-sm btn-primary-dark text-xxs fw-bold"
              >
                Retake Photo
              </button>

              <button
                v-if="photo_taken && !camera_loading && !camera_error"
                @click="submit_photo"
                class="btn btn-sm btn-primary-dark text-xxs fw-bold"
                :disabled="!photo_taken"
              >
                Submit Photo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>